<template>
  <div class="content">
    <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
      <el-form-item label="ICCID：" prop="iccids" label-width="151px">
        <el-input
          v-model="ruleForm.iccids"
          type="textarea"
          placeholder="以回车键分割ICCID"
          rows="6"
          style="width:420px"
        ></el-input>
      </el-form-item>
      <el-form-item label="ICCID范围：" prop="startIccid" label-width="151px">
        <el-input
          v-model="ruleForm.startIccid"
          style="width: 200px;margin-right: 10px;"
          placeholder="包含开始值"
        ></el-input>
        <span>-</span>
        <el-input
          v-model="ruleForm.endIccid"
          style="width: 200px;margin-left: 10px;"
          placeholder="包含终止值"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="medium" @click="poolRecyling" v-hasPermi="['pondManage:recycle']">提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { poolRecyclingPoolCard } from "@/api/api.js";
export default {
  name:"poolRecovery",
  data() {
    return {
      ruleForm: {},
    };
  },
  methods: {
    poolRecyling() {
      let data = {
        ...this.ruleForm,
        iccids:this.ruleForm.iccids ? this.ruleForm.iccids.split("\n") : []
      };
      poolRecyclingPoolCard(data).then(res => {
          this.$notify.info({
            title: "提示",
            message: "已提交卡回收，请在任务中心查看进度",
            duration: 1000,
            offset:30
          });
          setTimeout(()=>{
            this.$store.dispatch('tagsView/delView', this.$route)
            this.$router.push(`/taskCenter/missionList`);
          },1000)
      });
    }
  },
  created() {

  },
};
</script>
